import { useQuery } from '@tanstack/react-query';
import { getContactSettings } from '@/backend/services/contactSettings';

export function useContactSettings() {
  return useQuery({
    queryKey: ['contact-settings'],
    queryFn: getContactSettings,
    staleTime: 5 * 60 * 1000,
  });
}
